import React from 'react'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { ImageHelper, SchoolHelper } from '@laputan/helpers'
import { CONFIG } from '../../config'

const StyledSchoolLogo = styled(LazyLoadImage)`
  width: ${({ size }) => size && `${size}px`};
  height: ${({ size }) => size && `${size}px`};
`

interface ISchoolLogoProps {
  logo?: string
  size?: number
  className?: string
  alt?: string
}

const SchoolLogo: React.FC<ISchoolLogoProps> = ({
  logo,
  size = 50,
  className,
  alt,
}) => {
  let url = SchoolHelper.getSchoolImagePath({
    logo,
    size,
  })
  if (!url) {
    const templateUrl = `${CONFIG.LAPUTAN_IMAGE_SERVER_URL}/{size}x{size}/schools/school-logos/{handle}{fileExtension}`
    url = ImageHelper.getImagePath({
      handle: 'no-image.png',
      templateUrl,
      size: size * 2, // x2 - For retina display
    })
  }
  return (
    <StyledSchoolLogo
      alt={alt}
      draggable={false}
      className={className}
      src={url}
      size={size}
    />
  )
}

export { SchoolLogo }
